<template>
  <AddPackageForm :is-add="true" :set-flag="setFlag" parent-name="BusinessGoodsSkuPackage" />
</template>
<script>
import AddPackageForm from '../components/addPackageForm.vue';
import { GOODS_COMBO_TYPES } from '@/utils/constants';
export default {
  name: 'BusinessGoodsSkuPackageAdd',
  components: {
    AddPackageForm,
  },
  data() {
    return {};
  },
  computed: {
    setFlag() {
      return GOODS_COMBO_TYPES.PACKAGE;
    },
  },
  watch: {},

  mounted() {},
  methods: {},
};
</script>
